<template>
  <div id="laureat" v-if="about">
    <div id="content">
      <div v-if="about.ceremony">
        <div class="upper">
          <div class="title">
            Cérémonie de remise des prix
          </div>
        </div>

        <div class="block" v-html="about.ceremony"></div>
      </div>

      <div class="upper" id="mission">
        <div class="title">
          Mission
        </div>
      </div>

      <div class="block" v-html="about.mission"></div>

      <div class="upper" id="fondation">
        <div class="title">
          Conseil de fondation
        </div>
      </div>

      <div id="portrait" class="block" v-if="about.image.src">
        <div class="aboutPortraitInner" :style="{paddingBottom: about.image.ratio + '%'}" v-lazyload>
          <LazyImage :source="about.image.src" :blur="about.image.src_blur" />
          <div v-if="about.image_credits" class="caption" v-html="about.image_credits"></div>
        </div>
      </div>

      <div id="tabs" class="history">
        <div class="tab first">
          <div class="tabTitle" v-html="first.title"></div>
          <div class="tabText" v-html="first.text"></div>
        </div>

        <div class="firstFive">
          <Tab v-for="tab in firstfive" :tab="tab" :key="tab.title" />
        </div>

        <div class="more" @click="more = !more" v-if="conseil.length > 5">...</div>

        <div class="moreTabs" v-if="conseil.length > 5">
          <slide-up-down :active="more" :duration="500">
            <Tab v-for="tab in moreitems" :tab="tab" :key="tab.title" />
          </slide-up-down>
        </div>

      </div>

      <div class="upper" id="partenaires">
        <div class="title">
          Partenaires
        </div>
      </div>

      <div class="block" v-html="about.partners"></div>

      <div v-if="about.logos_fvpc" class="logos fvpc">
        <div class="logosInner">
          <img v-for="img in about.logos_fvpc" :key="img.src_low" :src="img.src_low">
        </div>
      </div>

      <div v-if="about.logos_sponsors" class="logos sponsors">
        <div class="subTitle">
          Mecenes
        </div>

        <div class="logosInner">
          <div class="logo" v-for="img in about.logos_sponsors" :key="img.src_low"><img :src="img.src_low"></div>
        </div>
      </div>

      <div v-if="about.logos_sponsors" class="logos sponsors">
        <div class="subTitle">
          Partenaires
        </div>

        <div class="logosInner">
          <div class="logo" v-for="img in about.logos_partners" :key="img.src_low"><img :src="img.src_low"></div>
        </div>
      </div>
      <p class="bc">Un remerciement particulier à Bernard Cosendai.</p>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/Tab'
import SlideUpDown from 'vue-slide-up-down'
import VueScrollTo from 'vue-scrollto'
import LazyImage from '@/components/LazyImage.vue'

export default {
  data () {
    return {
      more: false,
      options: {
        easing: 'ease-out',
        offset: 0,
        force: true,
        cancelable: false,
        x: false,
        y: true
      }
    }
  },

  components: {
    SlideUpDown,
    Tab,
    LazyImage
  },

  computed: {
    about () {
      return this.$store.getters.about
    },

    first () {
      let f = this.about.conseil.slice().pop()
      return f
    },

    conseil () {
      let rev = this.about.conseil.slice().reverse()
      return rev
    },

    firstfive () {
      let ff = []
      this.conseil.forEach((item, index) => {
        if (index !== 0 && index < 5) ff.push(item)
      })
      return ff
    },

    moreitems () {
      let ff = []
      this.conseil.forEach((item, index) => {
        if (index > 4) ff.push(item)
      })
      return ff
    }
  },

  mounted () {
    if (this.about && this.$route.params.slug) {
      let sT = this.$route.params.slug === 'ceremonie' ? 'container' : this.$route.params.slug
      VueScrollTo.scrollTo('#' + sT, 1, this.options)
    } else {
      this.$root.$emit('scrollAfterEnter')
    }
  },

  watch: {
    about () {
      this.$nextTick(() => {
        let sT = this.$route.params.slug === 'ceremonie' ? 'container' : this.$route.params.slug
        if (this.$route.params.slug) VueScrollTo.scrollTo('#' + sT, 1, this.options)
      })
    },

    '$route' (to, from) {
      if (to.name === from.name) {
        let sT = this.$route.params.slug === 'ceremonie' ? 'container' : this.$route.params.slug
        VueScrollTo.scrollTo('#' + sT, 500, this.options)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.aboutPortraitInner {
  position: relative;
  width: 100%;

  img {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }
}

.logos {
  width: 75%;
  margin: 0 auto;
}

.logo {
  width: 33.333%;
  text-align: center;
}

.logosInner {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  img {
    max-width: 18rem;
    max-height: 6rem;
    width: auto;
    height: auto;
    margin: 2rem;
  }
}

.portrait {
  margin: 0 0 1rem;
}

.logos.fvpc img {
  max-width: 12rem;
  max-height: 12rem;
}

.collapsed {
  margin: 0;

  .tabTitle {
    cursor: pointer;
  }

  .tabText {
    border-bottom: $line;
  }
}

.moreTabs .collapsed:last-child {
  .tabText {
    border-bottom: none;
  }
}

.firstFive .tab:first-child .tabTitle {
  border-top: $line;
}

.more {
  width: 100%;
  text-align: center;
  cursor: pointer;
  border-bottom: $line;
}

.bc {
  font-size: 1.5rem;
  width: 75%;
  margin: 1rem auto;
  text-align: center;
}

@media screen and (max-width: $breakPoint1) {
  .collapsed {
    .tabText {
      border-bottom: $line2;
    }
  }

  .firstFive .tab:first-child .tabTitle {
    border-top: $line2;
  }

  .more {
    border-bottom: $line2;
  }

  .logos {
    width: 100%;
  }

  .logosInner {
    div {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .bc {
    width: 100%;
  }
}
</style>
